const HREFLANG_TYPES = ["LiferayBlogPage", "LiferayFormConfiguration", "LiferayAssistance"];

const findHrefLang = (page) => {
  const hrefLangItem = page?.contentBody?.find(
    (item) => HREFLANG_TYPES.includes(item?.__typename) && !page?.seo
  );
  return hrefLangItem?.fields?.hrefLanguages;
};

export default findHrefLang;
